export const WITHDRAW_CONFIGS_LIST = "WITHDRAW_CONFIGS_LIST";
export const WITHDRAW_CONFIGS_CREATE = "WITHDRAW_CONFIGS_CREATE";
export const WITHDRAW_CONFIGS_UPDATE = "WITHDRAW_CONFIGS_UPDATE";
export const WITHDRAW_CONFIGS_DELETE = "WITHDRAW_CONFIGS_DELETE";
export const WITHDRAW_CONFIGS_SHOW = "WITHDRAW_CONFIGS_SHOW";
